import { render } from "./ObjetoIntegracaoConsultoria.vue?vue&type=template&id=28b8d7f9"
import script from "./ObjetoIntegracaoConsultoria.vue?vue&type=script&lang=js"
export * from "./ObjetoIntegracaoConsultoria.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__